import React, { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";

export const Journal = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get(`/blog`).then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <section id="journal" data-testid="journal-section" className="py-20 md:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between gap-6 mb-12">
          <div>
            <div className="font-mono-ui text-xs uppercase tracking-widest text-accent mb-3">
              — 03 / The Journal
            </div>
            <h2 className="font-display text-4xl md:text-6xl font-semibold tracking-tight leading-tight">
              Stories from<br />the ghani & the field
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {posts.map((post, i) => (
            <article
              key={post.id}
              data-testid={`blog-post-${post.id}`}
              className={`group relative rounded-2xl overflow-hidden border border-border hover-lift bg-card ${
                i === 0 ? "md:col-span-2 md:row-span-1" : ""
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? "aspect-[16/9]" : "aspect-[4/3]"}`}>
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-background/85 backdrop-blur text-foreground text-[10px] font-mono-ui uppercase tracking-widest rounded-full">
                  {post.category}
                </span>
              </div>
              <div className="p-5">
                <div className="text-xs font-mono-ui text-muted-foreground uppercase tracking-widest">
                  {post.date} · {post.read_time}
                </div>
                <h3 className={`mt-3 font-display font-semibold leading-tight ${i === 0 ? "text-2xl md:text-3xl" : "text-xl"}`}>
                  {post.title}
                </h3>
                <p className="mt-3 text-sm text-muted-foreground line-clamp-2">
                  {post.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs font-mono-ui text-muted-foreground">— {post.author}</span>
                  <ArrowUpRight className="w-5 h-5 text-accent transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
